/* eslint-disable no-prototype-builtins */
import Reflux from "reflux";
import logger from "../../utils/LoggerFrontend";
import { ActionsCampaignsOverview } from "../../Actions/ActionsCampaignsOverview/ActionsCampaignsOverview";

export default class CampaignsOverviewStore extends Reflux.Store {
  constructor() {
    super();

    this.state = {
      activeCampaignCount: 0,
      loadingActiveCampaignCount: true,
      activeApplicantsCount: 0,
      loadingActiveApplicantsCount: true
    };

    this.listenables = ActionsCampaignsOverview;
    this.onError = this.onError.bind(this);
  }

  onError(error) {
    logger.log(
      "CampaignsOverviewStore:onError",
      "An error occurred in the  Campaigns Overview Store:",
      error
    );
  }

  // Get active campaign count

  onGetActiveCampaignCount() {
    logger.log("CampaignsOverviewStore:onGetActiveCampaignCount", "called...");

    this.setState({
      loadingActiveCampaignCount: true
    });
  }

  onGetActiveCampaignCountCompleted(data) {
    logger.log("CampaignsOverviewStore:onGetActiveCampaignCountCompleted", "called...", {
      data
    });

    this.setState({
      activeCampaignCount: data.payload,
      loadingActiveCampaignCount: false
    });
  }

  onGetActiveCampaignCountFailed(error) {
    logger.log("error:CampaignsOverviewStore:onGetActiveCampaignCountFailed", "called...", {
      error
    });

    this.setState({ loadingActiveCampaignCount: false });
    this.onError(error);
  }

  // Get active applicants count

  onGetActiveApplicantsCount() {
    logger.log("CampaignsOverviewStore:onGetActiveApplicantsCount", "called...");

    this.setState({
      loadingActiveApplicantsCount: true
    });
  }

  onGetActiveApplicantsCountCompleted(data) {
    logger.log("CampaignsOverviewStore:onGetActiveApplicantsCountCompleted", "called...", {
      data
    });

    this.setState({
      activeApplicantsCount: data.payload,
      loadingActiveApplicantsCount: false
    });
  }

  onGetActiveApplicantsCountFailed(error) {
    logger.log("error:CampaignsOverviewStore:onGetActiveApplicantsCountFailed", "called...", {
      error
    });

    this.setState({ loadingActiveApplicantsCount: false });
    this.onError(error);
  }
}
